import { AnalyticEvents } from '@app/enums';

export const upsellCardMetaData: {
    [key: string]: {
        moduleName: string;
        header: string;
        tagline: string;
        description: string;
        CTAText: string;
        src: string;
        embedURL: string;
        taglineSrc?: string;
        CTAEvent: AnalyticEvents;
        learnMoreEvent?: AnalyticEvents;
        externalURL?: string;
    };
} = {
    'Time Off': {
        moduleName: 'Time Off',
        header: 'add-ons.time-off.header',
        tagline: 'add-ons.time-off.tagline',
        description: 'add-ons.time-off.description',
        CTAText: 'add-ons.time-off.CTAText',
        src: '/assets/illustrations/time-off.png',
        embedURL: 'https://embed.humi.ca/time-off-2',
        CTAEvent: AnalyticEvents.AddOnsTimeOffBookDemo,
        learnMoreEvent: AnalyticEvents.AddOnsTimeOffLearnMore,
    },
    Benefits: {
        moduleName: 'Benefits',
        header: 'add-ons.benefits.header',
        tagline: 'add-ons.benefits.tagline',
        description: 'add-ons.benefits.description',
        CTAText: 'add-ons.benefits.CTAText',
        src: '/assets/illustrations/benefits.png',
        embedURL: 'https://embed.humi.ca/benefits-3',
        taglineSrc: '/assets/illustrations/benefits-plus.png',
        CTAEvent: AnalyticEvents.AddOnsBenefitsBookConsult,
        learnMoreEvent: AnalyticEvents.AddOnsBenefitsLearnMore,
    },
    Recruiting: {
        moduleName: 'Recruiting',
        header: 'add-ons.recruiting.header',
        tagline: 'add-ons.recruiting.tagline',
        description: 'add-ons.recruiting.description',
        CTAText: 'add-ons.recruiting.CTAText',
        src: '/assets/illustrations/recruiting.png',
        embedURL: 'https://embed.humi.ca/recruiting-2',
        CTAEvent: AnalyticEvents.AddOnsRecruitingBookDemo,
        learnMoreEvent: AnalyticEvents.AddOnsRecruitingLearnMore,
    },
    Payroll: {
        moduleName: 'Payroll',
        header: 'add-ons.payroll.header',
        tagline: 'add-ons.payroll.tagline',
        description: 'add-ons.payroll.description',
        CTAText: 'add-ons.payroll.CTAText',
        src: '/assets/illustrations/payroll.png',
        embedURL: 'https://embed.humi.ca/payroll-2',
        CTAEvent: AnalyticEvents.AddOnsPayrollBookDemo,
        learnMoreEvent: AnalyticEvents.AddOnsPayrollLearnMore,
    },
    'Business Insurance': {
        moduleName: 'Business Insurance',
        header: 'add-ons.businessInsurance.header',
        tagline: 'add-ons.businessInsurance.tagline',
        description: 'add-ons.businessInsurance.description',
        CTAText: 'add-ons.businessInsurance.CTAText',
        src: '/assets/illustrations/product.png',
        embedURL: 'https://embed.humi.ca/business-insurance',
        CTAEvent: AnalyticEvents.AddOnsBusinessInsuranceBookConsult,
        learnMoreEvent: AnalyticEvents.AddOnsBusinessInsuranceLearnMore,
        externalURL: 'https://share.hsforms.com/1qFCWp1ZBTqelOaigNDr_1g2x9cg',
    },
    Performance: {
        moduleName: 'Performance',
        header: 'add-ons.performance.header',
        tagline: 'add-ons.performance.tagline',
        description: 'add-ons.performance.description',
        CTAText: 'add-ons.performance.CTAText',
        src: '/assets/illustrations/performance.png',
        embedURL: 'https://embed.humi.ca/performance-2',
        CTAEvent: AnalyticEvents.AddOnsPerformanceBookDemo,
        learnMoreEvent: AnalyticEvents.AddOnsPerformanceLearnMore,
    },
};
